import { useState } from 'react'
import "./style.css";
import { Checkbox, InlineStack, Text } from '@shopify/polaris';

const CustomToggle = ({ active, handleToggle, loading }) => {
    const [_active, setActive] = useState(active)

    return (
        // <label class="switch">
        //     <input type="checkbox" onChange={handleToggle} checked={active} />
        //     <span class="slider round"></span>
        // </label>
        <InlineStack gap={200} align='start' blockAlign='center'>
            <button class={`switch${active ? " active-switch" : ""}${loading ? " loading no-pointer-events" : ""}`} onClick={(e) => {
                e.stopPropagation()
                setActive(active => {
                    handleToggle(!active)
                    return !active
                })

            }}></button>
            <span className="status-text">
                <Text variant='bodyMd' as="p">{active ? "Active" : "Draft"}</Text>
            </span>
        </InlineStack>
    )
}

export default CustomToggle